var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "contest-entry-form-page",
      class: { "has-scroll-layout": _vm.loadState === "loaded" },
    },
    [
      _vm.loadState === "loading"
        ? _c(_setup.LoadingSpinner, {
            attrs: { size: "medium", variant: "inline" },
          })
        : _vm.loadState === "error"
        ? _c("p", { staticClass: "load-error", attrs: { role: "alert" } }, [
            _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
          ])
        : _vm.loadState === "loaded"
        ? [
            _c(
              "div",
              { staticClass: "layout" },
              [
                _c(
                  "aside",
                  { staticClass: "nav-column" },
                  [
                    _c(
                      "div",
                      { staticClass: "nav-top" },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "back-link",
                            attrs: { to: { name: "eventContest" } },
                          },
                          [
                            _c(_setup.IconChevronLeft, {
                              staticClass: "back-icon",
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _setup.t("contestEntryForm.backToContestList")
                                ) +
                                " "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(_setup.ContestEntryFormStepper, {
                      attrs: { "current-step": _vm.currentStep },
                    }),
                  ],
                  1
                ),
                _c("section", { staticClass: "main-column" }, [
                  _c(
                    "div",
                    { staticClass: "form-panel" },
                    [
                      _c("h1", { staticClass: "form-title" }, [
                        _vm._v(_vm._s(_vm.title)),
                      ]),
                      _vm.description
                        ? _c("p", { staticClass: "form-description" }, [
                            _vm._v(_vm._s(_vm.description)),
                          ])
                        : _vm._e(),
                      _vm._t("default"),
                    ],
                    2
                  ),
                ]),
                _c(_setup.ContestEntryFormContestAside, {
                  attrs: { contest: _vm.contest },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }